import { useSnackbar } from "../components/Snackbar";

export const useGetNewToken = () => {
  const { Snackbar, setSnackbarStatus } = useSnackbar();
  const getNewToken = async (withSnackbar = true) => {
    withSnackbar && setSnackbarStatus("working")

    const userData = localStorage.getItem('user');
    const parsedUserData = userData ? JSON.parse(userData) : {}

    try {
      const res = await fetch("https://api.blaszczak-development.pl/api/generate", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ user: parsedUserData })
      });
      const data = await res.json();
      if (!data.token) throw new Error(data.error);

      withSnackbar && setSnackbarStatus("done");
      localStorage.setItem('userData', JSON.stringify(data))

      return data
    } catch (e) {
      console.error(e);
      withSnackbar && setSnackbarStatus("error");
    } finally {
      withSnackbar && setTimeout(() => {
        setSnackbarStatus("idle");
      }, 2000)
    }
  }

  return { getNewToken, Snackbar }
}
